module.exports = __webpack_public_path__ + "static/media/Night Protector.f884f678.jpg";